export default "__VITE_ASSET__dffe0dcc__"